export default __webpack_public_path__ + "static/media/Custom Clearance.a9802216.jpeg";